import { zodResolver } from '@hookform/resolvers/zod';
import { FC, PropsWithChildren } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { IS_VALID_URL } from 'utils/validationRegex';
import { z } from 'zod';
import { LINK_ACTIONS, linksArrayName } from '../constants';
import { LinksFieldArray } from '../types';
import { useDataQueryContext } from './DataQueryContext';

const schema = z.object({
  [linksArrayName]: z.array(
    z
      .object({
        linkAction: z.string(),
        effectiveDate: z.string(),
        redirectLocation: z.string(),
        projectId: z.number().readonly(),
        projectName: z.string().readonly(),
      })
      .refine(
        (arg) => arg.linkAction !== LINK_ACTIONS.customRedirect || arg.redirectLocation !== '',
        {
          message: 'Location is required to redirect links',
          path: ['redirectLocation'],
        },
      )
      .refine(
        (arg) =>
          arg.linkAction !== LINK_ACTIONS.customRedirect || IS_VALID_URL.test(arg.redirectLocation),
        {
          message: 'Location must start with http:// or https://',
          path: ['redirectLocation'],
        },
      ),
  ),
});

export const LinksFormProvider: FC<PropsWithChildren> = ({ children }) => {
  const { links = [] } = useDataQueryContext();
  const defaultValues = { [linksArrayName]: links };

  const methods = useForm<LinksFieldArray>({
    defaultValues,
    mode: 'onSubmit',
    resolver: zodResolver(schema),
    reValidateMode: 'onChange',
    values: { [linksArrayName]: links },
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
